import { cn } from '@/functions/cn';

import { lensLoading } from '@/assets/icons/lib';

const PageLoader = ({
  className,
  text = '정보를 불러오고 있습니다',
  subText = '잠시만 기다려 주세요.',
}: {
  className?: string;
  text?: string;
  subText?: string;
}) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center text-center flex-col h-full',
        className
      )}
    >
      <img src={lensLoading} alt="logo" className="w-[50px] h-[50px] mb-16" />
      <div className="text-base font-medium text-gray-600 mb-4">{text}</div>
      <div className="text-sm text-gray-500">{subText}</div>
    </div>
  );
};

export default PageLoader;
